export const LOADING_SHEET_GO_BUTTON_API = 'LOADING_SHEET_GO_BUTTON_API'
export const LOADING_SHEET_GO_BUTTON_API_SUCCESS = 'LOADING_SHEET_GO_BUTTON_API_SUCCESS'

export const SAVE_LOADING_SHEET_MASTER = 'SAVE_LOADING_SHEET_MASTER'
export const SAVE_LOADING_SHEET_MASTER_SUCCESS = 'SAVE_LOADING_SHEET_MASTER_SUCCESS'

export const LOADING_SHEET_LIST_ACTION = 'LOADING_SHEET_LIST_ACTION'
export const LOADING_SHEET_LIST_ACTION_SUCCESS = 'LOADING_SHEET_LIST_ACTION_SUCCESS'

export const LOADING_SHEET_UPDATE_API = 'LOADING_SHEET_UPDATE_API'
export const LOADING_SHEET_UPDATE_API_ACTION_SUCCESS = 'LOADING_SHEET_UPDATE_API_ACTION_SUCCESS'

export const DELETE_LOADING_SHEET = 'DELETE_LOADING_SHEET'
export const DELETE_LOADING_SHEET_SUCCESS = 'DELETE_LOADING_SHEET_SUCCESS'


export const LOADING_LIST_PAGE_FILTERS_PARAMETER = 'LOADING_LIST_PAGE_FILTERS_PARAMETER'

export const LOADING_SHEET_API_ERROR_ACTION = 'LOADING_SHEET_API_ERROR_ACTION'


